<template lang="pug">
.invoice-data-container(@click="expand = !expand")
  .invoice-data
    .invoice-number
      span.material-symbols-outlined description
      span.tag {{ data.invoice }}

    .invoice-order
      span.material-symbols-outlined shopping_cart
      span.tag {{ data.order }}

    .invoice-type(v-if="!history") {{ data.type }}

    .invoice-process(v-if="!history && data.process" :class="processColor")
      span {{ processLabel(data.process) }}

    .invoice-value(v-if="!history") {{ money(data.value) }}

    .invoice-tax(v-if="!history") IVA {{ money(data.tax) }}

    .invoice-date {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

    .invoice-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

  .invoice-actions-container(@click.stop="")
    .invoice-actions
      .notifications(v-if="data.type !== 'Nota Credito'")
        img(:class="{disabled: dontSendNotifications}" src="https://sahet-cdn.b-cdn.net/img/others/notifications.svg" alt="notificaciones" @click="dontSendNotifications = !dontSendNotifications")

      .pdf-actions(v-if="!history && data.process")
        shActionButton(v-if="data.PDF" :action="goToPDF" text="Ver PDF" textRunning="Abriendo" :mini="true" @click.native.stop="")
        shActionButton(v-else :action="updateState" :params="[data.tascode]" text="Obtener PDF" textRunning="Obteniendo" :mini="true" @click.native.stop="")

      .buttons-actions(v-if="data.process === '2' && data.type !== 'Nota Credito' && data.order && data.order[0] !== 'p'")
        shActionButton(:action="cancele" :params="[data.invoice, data.order]" text="Anular" textRunning="Anulando")

      .buttons-actions(v-if="data.status === 'approved'")
        shActionButton(:action="disapprove" :params="[data.invoice]" text="Desaprobar" textRunning="Desaprobando")
        shActionButton(:action="invoice" :params="[data.invoice]" text="Facturar" textRunning="Facturando")

      .buttons-actions(v-if="data.status === 'invoiced'")
        shActionButton(:action="uninvoice" :params="[data.invoice]" text="Deshacer Factura" textRunning="Deshaciendo")

  .invoice-resend(@click.stop="" v-if="data.PDF")
    form(@submit.prevent="")
      .input-container
        input.input(v-model="email" type="email" autocomplete="off" required)
        label.label(:class="{ show: email }") Email reenvío
      shActionButton(:isForm="true" :action="resendEmail" text="Reenviar Correo" textRunning="Reenviando" :mini="true")

  transition(name="slide-fade")
    shForm.list-invoice(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-invoice(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import gqlInvoice from '@/graphql/invoice'
import gql from '@my/graphql'
import modals from '@my/store/modals'

export default {
  name: 'Invoice',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false,
      dontSendNotifications: false,
      email: ''
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    async cancele (invoice, order) {
      const mutation = gqlInvoice.CANCELE
      const response = await gql.mutate(mutation, { invoice, order })
      if (response && response.data && response.data.canceleInvoice) {
        modals.showMessage({ message: `Se anuló la factura de la orden ${order}` })
      }
    },

    async approve (invoice) {
      const mutation = gqlInvoice.APPROVE
      if (!invoice) return
      const response = await gql.mutate(mutation, { invoice, sendNotifications: !this.dontSendNotifications })
      if (response) modals.showMessage({ message: `Se aprobó la factura ${invoice}` })
    },

    async disapprove (invoice) {
      const mutation = gqlInvoice.DISAPPROVE
      if (!invoice) return
      const response = await gql.mutate(mutation, { invoice, sendNotifications: !this.dontSendNotifications })
      if (response) modals.showMessage({ message: `Se desaprobó la factura ${invoice}` })
    },

    async invoice (invoice) {
      const mutation = gqlInvoice.REFUND
      if (!invoice) return
      const response = await gql.mutate(mutation, { invoice, sendNotifications: !this.dontSendNotifications })
      if (response) modals.showMessage({ message: `Se facturó la factura ${invoice}` })
    },

    async uninvoice (invoice) {
      const mutation = gqlInvoice.UNREFUND
      if (!invoice) return
      const response = await gql.mutate(mutation, { invoice, sendNotifications: !this.dontSendNotifications })
      if (response) modals.showMessage({ message: `Se deshizo la factura ${invoice}` })
    },

    processLabel (process) {
      const codes = { 0: 'Enviado', 1: 'Verificando', 2: 'Aceptado DIAN', 78: 'Reintentando' }
      return codes[process] || 'Rechazado DIAN'
    },

    async updateState (tascode) {
      const mutation = gqlInvoice.UPDATE_STATE
      const response = await gql.mutate(mutation, { tascode })
      if (response && response.data && response.data.updateStateInvoice) {
        const { process, URL, PDF } = response.data.updateStateInvoice
        this.data.process = process
        this.data.URL = URL
        this.data.PDF = PDF
        modals.showMessage({ message: `Se actualizó el estado de la factura` })
      }
    },

    goToPDF () {
      window.open(this.data.PDF, '_blank')
    },

    async resendEmail () {
      const mutation = gqlInvoice.RESEND_EMAIL
      const response = await gql.mutate(mutation, { tascode: this.data.tascode, email: this.email })
      if (response && response.data && response.data.resendEmailInvoice) {
        modals.showMessage({ message: `Se reenvió la factura al email ${this.email}` })
      }
    },

    translateStatus (status) {
      const map = {
        created: 'Creado',
        approved: 'Aprobado',
        invoiced: 'Facturado',
        declined: 'Declinado'
      }
      return map[status] || status
    }
  },

  computed: {
    styleStatus () {
      const colors = {
        created: { background: '#e9e9e7', color: '#616161' },
        approved: { background: '#A5AA72', color: '#ffffff' },
        invoiced: { background: '#56AEFF', color: '#ffffff' },
        declined: { background: '#AA7572', color: '#ffffff' }
      }
      const c = colors[this.data.status]
      if (!c) return ''
      return `background: ${c.background}; color: ${c.color}`
    },

    processColor () {
      const p = this.data.process
      if (p === '2') return 'color-green'
      if (p === '0' || p === '1' || p === '78') return ''
      return 'color-red'
    }
  }
}
</script>

<style lang="stylus">
.invoice-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.invoice-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis calc(100% - 3rem)
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.invoice-actions-container
  display flex
  align-items center
  gap 1.5rem
  padding 0 1rem
  flex-wrap wrap

.invoice-actions
  display flex
  align-items center
  gap 1em
  flex-wrap wrap

.invoice-actions .notifications img
  height 1.3em
  cursor pointer

.invoice-actions .notifications img.disabled
  opacity .2

.invoice-number, .invoice-order
  display flex
  align-items center
  gap .5em

.invoice-resend
  flex-basis 100%
  flex-shrink 0
  padding 0 1rem
  opacity .5
  transition opacity .2s

.invoice-resend:hover
  opacity 1

.invoice-resend form
  display flex
  align-items center
  gap 1em
  flex-wrap wrap

.invoice-resend .input-container
  display inline-block
  width 100%
  max-width 25em
  font-size .8em

.list-invoice
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .invoice-data
    flex-basis calc(100% - 20rem - 5rem)
    column-gap 0
    row-gap 1em

  .invoice-number
    width 10em
  .invoice-order
    width 10em
  .invoice-type
    width 8em
  .invoice-status
    width 7em
  .invoice-process
    width 9em
  .invoice-value
    width 8em
  .invoice-tax
    width 8em
  .invoice-date
    width 10em
  .invoice-transaction
    width 8em
  .invoice-actions
    width 20em

  .invoice-actions-container
    padding 0
</style>



// WEBPACK FOOTER //
// src/components/pages/invoice/Invoice.vue